;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:linkedregistrations-ui":true});}catch(e){}}();import composeQuery from './composeQuery';

export interface VariableToKeyItem {
  key: string;
  value: unknown;
}

const queryBuilder = (items: VariableToKeyItem[]): string => {
  let query = '';
  items.forEach((item) => {
    /* istanbul ignore else */
    if (Array.isArray(item.value) && item.value?.length) {
      query = composeQuery(query, item.key, item.value.join(','));
    } else if (typeof item.value === 'boolean') {
      query = composeQuery(query, item.key, item.value ? 'true' : 'false');
    } else if (typeof item.value === 'number') {
      query = composeQuery(query, item.key, item.value.toString());
    } else if (typeof item.value === 'string') {
      query = composeQuery(query, item.key, item.value);
    }
  });

  return query;
};

export default queryBuilder;
